module.exports = __webpack_public_path__ + "icon_horns.403147ba0b97d623fa62622aecb12536.svg";